import { RiTimerLine, RiTruckLine, RiCheckboxCircleLine, RiCloseCircleLine } from "react-icons/ri";
import type { OrderStatus } from "../../types/orders";

/** Ícone correspondente ao status do pedido. */
export function OrderStatusIcon({ status, size = 18 }: { status: OrderStatus; size?: number }) {
    switch (status) {
        case "aguardando-pagamento":
            return <RiTimerLine size={size} />;
        case "enviado":
            return <RiTruckLine size={size} />;
        case "concluido":
            return <RiCheckboxCircleLine size={size} />;
        default:
            return <RiCloseCircleLine size={size} />;
    }
}
